<div *ngIf="isEditModeEnabled || question.answer || question.gif">
  <div class="fs-16px sp-mb-6 fw-500" [attr.data-test-id]="'check-in-question-name'" [attr.aria-label]="text" tabindex="0">{{ text }}</div>
  <rich-text-editor
    *ngIf="isEditModeEnabled || question.answer"
    [team]="team"
    [teams]="teams"
    [isOKRLinkSelectorEnabled]="true"
    [a11yLabel]="a11yLabel"
    [gif]="gif"
    [text]="answer"
    [focusOnEditable]="false"
    [hideToolbarWhenUnfocused]="true"
    [contentOnly]="!isEditModeEnabled"
    [hidePostButton]="true"
    [placeholder]="placeholder"
    [autofocus]="autofocus"
    (editorFocus)="addDefaultText()"
    (textChange)="updateQuestion($event)"
    (gifChange)="gifChange($event)"
    (okrLinkClick)="okrLinkClick.emit($event)"
    tabindex="0"></rich-text-editor>
</div>
<div class="sp-ml-8" *ngIf="question.gif && !isEditModeEnabled">
  <gif-view [gifSize]="sizeOfGif.Small" [gif]="question.gif" [isResponsive]="true"></gif-view>
</div>
